function selectOnFocus($window) {
	return {
		restrict: "A",
		link(scope, element) {
			element.on("focus", setSelection);
			scope.$on("$destroy", () => {
				element.off("focus", setSelection);
			});

			function setSelection() {
				try {
					if(!$window.getSelection().toString()) {
						this.setSelectionRange(0, this.value.length);
					}
				}catch(e) {}//eslint-disable-line no-empty
			}
		}
	};
}

export default angular
	.module("vesl.behaviors.select-on-focus", [])
	.directive("selectOnFocus", selectOnFocus).name;
